import { fabric } from 'fabric';

export default function initExpandCanvas({ width, height, backgroundColor }) {
  const drawingCanvas = new fabric.Canvas('drawing-expand-canvas', {
    selection: false,
    width,
    height,
    enableRetinaScaling: false,
    backgroundColor,
  });

  window.expandDrawingCanvas = drawingCanvas;
}
